<template>
    <main></main>
</template>

<script>
    export default {
        mounted() {
            this.$auth.logout()
            window.location.assign('/login')
        }
    }
</script>

<style scoped>

</style>
